/**
 * Workspace: the account itself. Who is in it, what they may do, and the
 * record of what they did - Intercom's grouping, name for name.
 */
export default ({ t, accountScopedRoute, hasSecuritySettings }) => ({
  name: 'Settings Workspace',
  label: t('SIDEBAR.SETTINGS_GROUP_WORKSPACE'),
  icon: 'i-ph-buildings',
  defaultFolded: true,
  children: [
    {
      name: 'Settings General',
      label: t('SIDEBAR.GENERAL'),
      icon: 'i-ph-gear-six',
      to: accountScopedRoute('general_settings_index'),
    },
    {
      name: 'Settings Teammates',
      label: t('SIDEBAR.TEAMMATES'),
      icon: 'i-ph-user-square',
      to: accountScopedRoute('agent_list'),
      // Roles and Activity are tabs on Teammates; their standalone routes stay
      // reachable as deep links and should light this entry when visited.
      activeOn: ['custom_roles_list', 'auditlogs_list'],
    },
    // SAML is the entire Security page: when the plan paywalls it there is
    // nothing behind the link but an upgrade prompt, so drop the entry rather
    // than lead people to a dead end. The route itself stays reachable by URL.
    ...(hasSecuritySettings
      ? [
          {
            name: 'Settings Security',
            label: t('SIDEBAR.SECURITY'),
            icon: 'i-ph-lock-key',
            to: accountScopedRoute('security_settings_index'),
          },
        ]
      : []),
  ],
});
